module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if(isFilter){
    ; __append("\r\n    <li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis\" title=\"")
    ; __append(escapeFn(tooltip))
    ; __append("\" >\r\n        <a href=\"#\" data-target=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-select field-list-toggle\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"toggle\"\r\n           data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n            <i class=\"fa pf-carot-left pf-rotate-icon\" aria-expanded=\"true\"></i>\r\n        </a>\r\n        <a href=\"#\" data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-select field-list-toggle\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"label\"\r\n           data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n            ")
    ; __append(escapeFn(name ))
    ; __append("\r\n        </a>\r\n        <ul class=\"control-list ")
    ; __append(escapeFn(id))
    ; __append("\" control-id=\"")
    ; __append(escapeFn(id))
    ; __append("\" id=\"control-list-")
    ; __append(escapeFn( id ))
    ; __append("\" data-selected-control=\"")
    ; __append(escapeFn(id))
    ; __append("\" style=\"display: none; padding-left: 0\" title=\"\"></ul>\r\n    </li>\r\n")
    ; }else{
    ; __append("\r\n    <li style=\"padding-left: 1.3em\" class=\"table-ellipsis\">\r\n        <div class=\"select-field-header\">\r\n        <a href=\"#\" class=\"field-select\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\"\r\n           data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\"  data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\">\r\n            <i class=\"fa ")
    ; __append(escapeFn(icon))
    ; __append("\" style=\"font-size: ")
    ; __append(escapeFn(iconSize))
    ; __append("; vertical-align: middle;\"></i>\r\n            ")
    ; __append(escapeFn(name ))
    ; __append("\r\n        </a>\r\n    </div>\r\n    </li>\r\n\r\n")
    ; }
  }
  return __output;

}